import { CSS } from '@grupoboticario/flora-react'

export const modalWrapperCss: CSS = {
  width: '100%'
}

export const centeredTextCss: CSS = {
  textAlign: 'center',
  lineHeight: '24px'
}

export const centeredCss: CSS = {
  textAlign: 'center'
}

export const clickableRowCss: CSS = {
  cursor: 'pointer'
}

export const emphasizedTextCss: CSS = {
  textAlign: 'center',
  color: '$nonInteractiveEmphasis'
}
